import { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

const UserInfoLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={26}
      backgroundColor={theme.colors.primary.variant1}
      foregroundColor={theme.colors.rgba.variant2}
      data-testid="userinfo-loader"
    >
      <circle cx="13" cy="13" r="13" />
      <rect x="40" y="2" rx="6" ry="6" width="190" height="18" />
    </ContentLoader>
  );
};

export default UserInfoLoader;
